module.exports = __webpack_public_path__ + "img/armando-01.af926497.png";